"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _javascript = _interopRequireDefault(require("highlight.js/lib/languages/javascript"));

var _default = _javascript.default;
exports.default = _default;